import { render } from "./SubjectDropoutDialog.vue?vue&type=template&id=2fc9c5b5&scoped=true"
import script from "./SubjectDropoutDialog.vue?vue&type=script&lang=js"
export * from "./SubjectDropoutDialog.vue?vue&type=script&lang=js"

import "./SubjectDropoutDialog.vue?vue&type=style&index=0&id=2fc9c5b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc9c5b5"]])

export default __exports__